import { render, staticRenderFns } from "./CartShippingCard.vue?vue&type=template&id=6a979433&scoped=true&"
import script from "./CartShippingCard.vue?vue&type=script&lang=js&"
export * from "./CartShippingCard.vue?vue&type=script&lang=js&"
import style0 from "./CartShippingCard.vue?vue&type=style&index=0&id=6a979433&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a979433",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
